import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import customerSlice from "./slices/customerSlice";
import customerServiceSlice from "./slices/customerServicesSlice";
import accountSlice from "./slices/accountSlice";
import customerTransactionsSlice from "./slices/customerTransactionsSlice";
import maintenanceSlice from "./slices/maintenanceSlice";
import notificationSlice from "./slices/notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    customers: customerSlice,
    customerServices: customerServiceSlice,
    customerTransactions: customerTransactionsSlice,
    account: accountSlice,
    maintenance: maintenanceSlice,
    notifications: notificationSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
